import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { autoinject } from 'aurelia-framework';
import { StringHelper } from '../../../Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
export class EnumFormatterBaseValueConverter {

    protected i18n: I18N = null;

    constructor(i18n: I18N) {
        this.i18n = i18n;
    }

    toView(value, schemaColumn) {
        switch (schemaColumn.Type_FK) {
            case 9:
                {
                    if (ObjectHelper.ArrayIs(value) && ObjectHelper.ObjectIs(schemaColumn) && StringHelper.StringIs(schemaColumn.EnumType)) {
                        let enumType: any = SystemService.Instance.GetStorageItem('Enum', schemaColumn.EnumType);
                        if (ObjectHelper.ObjectIs(enumType) && ObjectHelper.ArrayIs(enumType.Items)) {
                            let enums: Array<any> = enumType.Items;
                            if (ObjectHelper.ArrayIs(enums)) {
                                let filterEnums: Array<any> = enums.filter((item) => value.indexOf(item.Id ) >= 0);
                                if (ObjectHelper.ArrayIs(filterEnums)) {
                                    let res = '';
                                    for (let i2 = 0; i2 < filterEnums.length; i2++) {
                                        if (StringHelper.StringIs(res)){
                                            res = res + ', ';
                                        }
                                        res = res + filterEnums[i2].Caption;
                                    }
                                    return res;
                                }
                            }
                        }
                    }
                }
                break;
            case 8:
            case 40:
                {
                    if (ObjectHelper.IsNotNullAndUndefined(value) && value > 0 && ObjectHelper.ObjectIs(schemaColumn) && StringHelper.StringIs(schemaColumn.EnumType)) {
                        let enumType: any = SystemService.Instance.GetStorageItem('Enum', schemaColumn.EnumType);
                        if (ObjectHelper.ObjectIs(enumType) && ObjectHelper.ArrayIs(enumType.Items)) {
                            let enums: Array<any> = enumType.Items;
                            if (ObjectHelper.ArrayIs(enums)) {
                                let filterEnums: Array<any> = enums.filter((item) => item.Id == value);
                                if (ObjectHelper.ArrayIs(filterEnums)) {
                                    let res = filterEnums[0].Caption;
                                    //console.log(7777777, filterEnums[0])
                                    if(StringHelper.StringIs(filterEnums[0].Icon)){
                                        res = `<i class="${filterEnums[0].Icon}" style="color: ${StringHelper.StringIs(filterEnums[0].IconColor) ? filterEnums[0].IconColor : '#fb8c00'};"></i> `+ res;
                                    }
                                    return res;
                                }
                            }
                        }
                    }

                }
                break;
            case 21:
                {
                    if (ObjectHelper.IsNotNullAndUndefined(value) && value > 0 && ObjectHelper.ObjectIs(schemaColumn) && StringHelper.StringIs(schemaColumn.EntityNameType_FK)) {
                        let list: any = SystemService.Instance.GetStorageItem('EntityList', schemaColumn.EntityNameType_FK);
                        if (ObjectHelper.ArrayIs(list)) {
                            let filterEnums: Array<any> = list.filter((item) => item.Id == value);
                            if (ObjectHelper.ArrayIs(filterEnums)) {
                                return filterEnums[0].Caption;
                            }
                        }
                    }
                }
                break;
            case 47:
                {
                    let result: string = '';
                    if (ObjectHelper.ArrayIs(value) && ObjectHelper.ObjectIs(schemaColumn) && StringHelper.StringIs(schemaColumn.EntityNameType_FK)) {
                        let list: any = SystemService.Instance.GetStorageItem('EntityList', schemaColumn.EntityNameType_FK);
                        if (ObjectHelper.ArrayIs(list)) {
                            for (let i1 = 0; i1 < value.length; i1++) {
                                const item = ObjectHelper.GetFirstItemOfArrayByProperty(list, 'Id', value[i1]);
                                if (ObjectHelper.ObjectIs(item)) {
                                    if (StringHelper.StringIs(result)) {
                                        result = result + ', ';
                                    }
                                    result = result + item.Caption;
                                }
                            }
                        }
                    }
                    return result;
                }
                break;
        }
        return value;
    }
}





